import { request } from '@/api/request';
import type {
  OwnProduct,
  Product,
  CreateProductRequest,
  EditProductRequest,
} from '@/types/models/products';

const getOrganisationProducts = (organisationID: string) =>
  request<Product[]>('GET', `/organisations/${organisationID}/products`);

const getOwnProducts = () => request<OwnProduct[]>('GET', '/products');

const createProduct = (req: CreateProductRequest) => request<Product>('POST', '/products', req);

const updateProduct = (req: EditProductRequest) =>
  request<Product>('PUT', `/products/${req.productID}`, req);

const archiveProduct = (productID: string) =>
  request<Product>('POST', `/products/${productID}/archive`);

const getSupplierAssociatedProductIDs = (supplierID: string) =>
  request<string[]>('GET', `/suppliers/${supplierID}/associated-products`);

const getClientAssociatedProductIDs = (clientID: string) =>
  request<string[]>('GET', `/clients/${clientID}/associated-products`);

export type SetSupplierAssociatedProductsRequest = {
  supplierID: string;
  productIDs: string[];
};

const setSupplierAssociatedProducts = (req: SetSupplierAssociatedProductsRequest) =>
  request<string[]>('PUT', `/suppliers/${req.supplierID}/associated-products`, {
    productIDs: req.productIDs,
  });

export type SetClientAssociatedProductsRequest = {
  clientID: string;
  productIDs: string[];
};

const setClientAssociatedProducts = (req: SetClientAssociatedProductsRequest) =>
  request<string[]>('PUT', `/clients/${req.clientID}/associated-products`, {
    productIDs: req.productIDs,
  });

const api = {
  getOrganisationProducts,
  getOwnProducts,
  createProduct,
  updateProduct,
  archiveProduct,
  getSupplierAssociatedProductIDs,
  getClientAssociatedProductIDs,
  setSupplierAssociatedProducts,
  setClientAssociatedProducts,
};

export default api;
